export const state = {
    etiqueta: {},
    etiquetas: [],
    modalExcluirEtiqueta: false,
    modalCadastrarEtiqueta: false,
    modalImprimirEtiqueta: false,
}

export default {}